import { VersionStateType } from "src/models/ts/version-state-type.model";

export const DELETESTATES  = [VersionStateType.ActiveDeleted, VersionStateType.DraftDeleted, VersionStateType.ArchiveDeleted, VersionStateType.PrePublicationDeleted]